import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IconMessagesConfig} from '../../../core/interfaces/icon-messages-config';

@Component({
  selector: 'app-global-messages-modal',
  templateUrl: './global-messages-modal.component.html',
  styleUrls: ['./global-messages-modal.component.scss']
})
export class GlobalMessagesModalComponent implements OnInit {
  public streamerName: string;
  public promoCode: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: IconMessagesConfig,
              public dialogRef: MatDialogRef<GlobalMessagesModalComponent>,
              private readonly snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.data.type === 'promo') {
      const message = this.data.iconMessage[0].message;

      const startIndex = message.indexOf('<b>') + 3;
      const endIndex = message.indexOf('</b>');
      this.streamerName = message.substring(startIndex, endIndex);

      const promoCodeStartIndex = message.lastIndexOf('<b>') + 3;
      const promoCodeEndIndex = message.lastIndexOf('</b>');
      this.promoCode = message.substring(promoCodeStartIndex, promoCodeEndIndex);
    }
  }
  public hideModal(): void {
    this.data.closeModal = false;
    this.dialogRef.close();
  }
  public closeModal(): void {
    this.dialogRef.close();
  }
  public copyText(): void {
    this.snackBar.open('Промокод скопирован!', 'Закрыть');
  }
  public getMessageForModal(type: string): string {
    const message = this.data.iconMessage.find(msg => msg.type === type);

    return message ? message.message : '';
  }
}
